const flippableWords = ["Sporten", "Spelen", "Proeven"];
const icons = [
    {
        name: "bal",
        url: "/Images/sportinvenray/bal.png"
    },
    {
        name: "fruit",
        url: "/Images/sportinvenray/fruit.png"
    },
    {
        name: "gitaar",
        url: "/Images/sportinvenray/gitaar.png"
    },
    {
        name: "microfoon",
        url: "/Images/sportinvenray/microfoon.png"
    },
    {
        name: "skateboard",
        url: "/Images/sportinvenray/skateboard.png"
    },

]
const heroTextElement = document.querySelector(".homepage-hero-title");
const iconWrapper = document.querySelector(".homepage-hero-wrapper-small");
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) && window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

function createTopTextElement(text: string) {
    const topTextElement = document.createElement("span");
    topTextElement.classList.add("top-text");
    topTextElement.textContent = text;
    heroTextElement!.appendChild(topTextElement);
}

function createTextflipElement(text: string) {
    const textFlipElement = document.createElement("span");
    textFlipElement.classList.add("text-flip");
    textFlipElement.textContent = text;
    heroTextElement!.appendChild(textFlipElement);
}

function textFlip() {
    const wordArray = flippableWords;
    const element = document.getElementsByClassName("text-flip")[0];

    const resetAnimation = function () {
        element.classList.remove("flip");
    };

    let wordIndex = 1;
    setInterval(function () {
        wordArray.forEach((word, index) => {
            if (wordIndex === index) {
                element.textContent = word;
                element.classList.add("flip");
                setTimeout(resetAnimation, 200);
            }
        });
        wordIndex = wordIndex + 1;
        if (wordIndex >= wordArray.length) {
            wordIndex = 0;
        }
    }, 2500);
}

function createIconElements() {
    const iconContainer = document.createElement("div");
    iconContainer.classList.add("icon-container");
    iconWrapper!.insertBefore(iconContainer, iconWrapper!.lastElementChild);

    icons.forEach(icon => {
        const iconElement = document.createElement("img");
        iconElement.src = icon.url;
        iconElement.alt = icon.name;
        iconElement.classList.add(`icon-${icon.name}`);
        iconContainer.appendChild(iconElement);
    });
}


window.addEventListener("DOMContentLoaded", () => {
    if (!heroTextElement || !iconWrapper) return;

    heroTextElement!.textContent = "";
    heroTextElement!.classList.remove("reveal");
    createIconElements();

    if (!isReduced) {
        createTopTextElement("Mee");
        createTextflipElement("Sporten");
        textFlip();
    }
});